import { render, staticRenderFns } from "./TableGiftCode.vue?vue&type=template&id=be801074&scoped=true&"
import script from "./TableGiftCode.vue?vue&type=script&lang=js&"
export * from "./TableGiftCode.vue?vue&type=script&lang=js&"
import style0 from "./TableGiftCode.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TableGiftCode.vue?vue&type=style&index=1&id=be801074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be801074",
  null
  
)

export default component.exports